import { ChangeEvent, useMemo, useState } from 'react';
import { isAcceptableImageType } from '../utility/isAcceptableImageType';

export const useValidateUploadImage = (maxSize: number) => {
  const [error, setError] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target === null || event.target.files === null) {
      setError('ファイルが選択されていません。');
      return;
    }
    let file = event.target.files[0],
      size = file.size,
      type = file.type;
    try {
      if (size > maxSize) {
        throw new Error('ファイルの上限サイズを超えています。\n');
      }
      //拡張子は .jpg .gif .png  のみ許可
      if (!isAcceptableImageType(type)) {
        throw new Error('.jpg、.gif、.png、のいずれかのファイルのみ許可されています。\n');
      }
      setFile(file);
      setError('');
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      setFile(null);
    }
  };
  const reset = () => {
    setFile(null);
    setError('');
  };

  const previewUrl = useMemo(() => {
    return file === null ? '' : URL.createObjectURL(file);
  }, [file]);

  return {
    error,
    file,
    onChange,
    isValid: error === '',
    previewUrl,
    reset,
  };
};
